import Layout1 from "../src/pages/Layout1/Layout1";

const routes = [{ path: "/", component: <Layout1 /> }];

export default routes;
